export enum ResultState {
    cancelled = 'cancelled',
    completed = 'completed',
    error = 'error',
    pending = 'pending',
}
